<template>
  <section class="company-history">
    <navigation-sub :list="navHistory" />

    <div class="company-title-wrap">
      <h4 class="company-title">{{ $t('menuCompany.history') }}</h4>
    </div>

    <div class="company-history-list">
      <div id="history-2026" class="year article-anchor">
        <div class="year-head">
          <time>2026</time>
          <html-view :value="$t('history.list.2026.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2026-6" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.jun.goal')" tag="p" />
              <html-view :value="$t('history.list.2026.jun.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202606_1.jpg 2x">
                <img src="~@/static/image/history/pc/202606_1.jpg" :alt="$t('history.list.2026.jun.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2026-5" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.may.goal1')" tag="p" />
              <html-view :value="$t('history.list.2026.may.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202605_1.jpg 2x">
                <img src="~@/static/image/history/pc/202605_1.jpg" :alt="$t('history.list.2026.may.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.may.goal2')" tag="p" />
              <html-view :value="$t('history.list.2026.may.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2026-4" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.apr.goal1')" tag="p" />
              <html-view :value="$t('history.list.2026.apr.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.apr.goal2')" tag="p" />
              <html-view :value="$t('history.list.2026.apr.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.apr.goal3')" tag="p" />
              <html-view :value="$t('history.list.2026.apr.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202604_1.jpg 2x">
                <img src="~@/static/image/history/pc/202604_1.jpg" :alt="$t('history.list.2026.apr.goal3')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2026-3" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2026.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202603_1.jpg 2x">
                <img src="~@/static/image/history/pc/202603_1.jpg" :alt="$t('history.list.2026.mar.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2026-2" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.feb.goal1')" tag="p" />
              <html-view :value="$t('history.list.2026.feb.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202602_1.jpg 2x">
                <img src="~@/static/image/history/pc/202602_1.jpg" :alt="$t('history.list.2026.feb.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.feb.goal2')" tag="p" />
              <html-view :value="$t('history.list.2026.feb.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202602_2-v2.jpg 2x">
                <img src="~@/static/image/history/pc/202602_2-v2.jpg" :alt="$t('history.list.2026.feb.goal2')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2026-1" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.jan.goal1')" tag="p" />
              <html-view :value="$t('history.list.2026.jan.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202601_1.jpg 2x">
                <img src="~@/static/image/history/pc/202601_1.jpg" :alt="$t('history.list.2026.jan.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2026.jan.goal2')" tag="p" />
              <html-view :value="$t('history.list.2026.jan.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202601_2.jpg 2x">
                <img src="~@/static/image/history/pc/202601_2.jpg" :alt="$t('history.list.2026.jan.goal2')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2025" class="year article-anchor">
        <div class="year-head">
          <time>2025</time>
          <html-view :value="$t('history.list.2025.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2025-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.dec.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.dec.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202512_2.jpg 2x">
                <img src="~@/static/image/history/pc/202512_2.jpg" :alt="$t('history.list.2025.dec.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.dec.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.dec.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month month-202510">
            <time datetime="2025-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.oct.goal')" tag="p" />
              <html-view :value="$t('history.list.2025.oct.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202510.jpg 2x">
                <img src="~@/static/image/history/pc/202510.jpg" :alt="$t('history.list.2025.oct.goal1')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2025-09" class="animation up">{{ $t('history.month.sep') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.sep.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.sep.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.sep.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.sep.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202509.jpg 2x">
                <img src="~@/static/image/history/pc/202509.jpg" :alt="$t('history.list.2025.sep.goal1')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2025-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.aug.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.aug.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.aug.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.aug.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2025-07" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jul.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.jul.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jul.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.jul.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202507.png">
                <img src="~@/static/image/history/pc/202507.png" :alt="$t('history.list.2025.may.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jul.goal3')" tag="p" />
              <html-view :value="$t('history.list.2025.jul.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2025-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jun.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.jun.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202506.png" :alt="$t('history.list.2025.jun.goal1')">
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jun.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.jun.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jun.goal3')" tag="p" />
              <html-view :value="$t('history.list.2025.jun.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2025-05" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.may.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.may.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source srcset="~@/static/image/history/pc/202505.png 3x">
                <img src="~@/static/image/history/pc/202505.png" :alt="$t('history.list.2025.may.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.may.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.may.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.may.goal3')" tag="p" />
              <html-view :value="$t('history.list.2025.may.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2025-04" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.apr.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.apr.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.apr.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.apr.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202504_2.jpg" :alt="$t('history.list.2025.apr.goal1')">
            </div>
          </div>
          <div class="month">
            <time datetime="2025-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.mar.goal1')" tag="p" />
              <html-view :value="$t('history.list.2025.mar.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.mar.goal2')" tag="p" />
              <html-view :value="$t('history.list.2025.mar.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.mar.goal3')" tag="p" />
              <html-view :value="$t('history.list.2025.mar.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.mar.goal4')" tag="p" />
              <html-view :value="$t('history.list.2025.mar.goalDetail4')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202503.jpg" :alt="$t('history.list.2025.mar.goal4')">
            </div>
          </div>
          <div class="month">
            <time datetime="2025-02" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.feb.goal')" tag="p" />
              <html-view :value="$t('history.list.2025.feb.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2025-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2025.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2025.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202501.png" :alt="$t('history.list.2025.jan.goal')">
            </div>
          </div>
        </div>
      </div>

      <div id="history-2024" class="year article-anchor">
        <div class="year-head">
          <time>2024</time>
          <html-view :value="$t('history.list.2024.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2024-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2024.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202412.jpg" :alt="$t('history.list.2024.dec.goal')">
            </div>
          </div>
          <div class="month">
            <time datetime="2024-11" class="animation up">{{ $t('history.month.nov') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.nov.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.nov.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.nov.goal2')" tag="p" />
              <!--<html-view :value="$t('history.list.2024.nov.goalDetail2')" class="month-goal-desc" tag="p" />-->
            </div>
          </div>
          <div class="month">
            <time datetime="2024-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.oct.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.oct.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.oct.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.oct.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/202410.jpg" :alt="$t('history.list.2024.oct.goal')">
            </div>
          </div>
          <div class="month">
            <time datetime="2024-09" class="animation up">{{ $t('history.month.sep') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.sep.goal')" tag="p" />
              <!--<html-view :value="$t('history.list.2024.sep.goalDetail')" class="month-goal-desc" tag="p" />-->
            </div>
          </div>
          <div class="month">
            <time datetime="2024-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.aug.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.aug.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.aug.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.aug.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-07" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.jul.goal')" tag="p" />
              <html-view :value="$t('history.list.2024.jul.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.jun.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.jun.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202406@3x.png 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202406@3x.png 3x">
                <img src="~@/static/image/history/pc/202406.png" :alt="$t('history.list.2022.sep.goal2')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.jun.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.jun.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-05" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.may.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.may.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202405@3x.png 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202405@3x.png 3x">
                <img src="~@/static/image/history/pc/202405.png" :alt="$t('history.list.2022.sep.goal2')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.may.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.may.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-04" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.apr.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.apr.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202404@3x.png 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202404@3x.png 3x">
                <img src="~@/static/image/history/pc/202404.png" :alt="$t('history.list.2022.sep.goal2')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.apr.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.apr.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.mar.goal1')" tag="p" />
              <html-view :value="$t('history.list.2024.mar.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.mar.goal2')" tag="p" />
              <html-view :value="$t('history.list.2024.mar.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.mar.goal3')" tag="p" />
              <html-view :value="$t('history.list.2024.mar.goalDetail3')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-02" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.feb.goal')" tag="p" />
              <html-view :value="$t('history.list.2024.feb.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2024-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2024.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2024.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2023" class="year article-anchor">
        <div class="year-head">
          <time>2023</time>
          <html-view :value="$t('history.list.2023.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2023-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.dec.goal1')" tag="p" />
              <html-view :value="$t('history.list.2023.dec.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202312@x3.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202312@x3.jpg 3x">
                <img src="~@/static/image/history/pc/202312.jpg" :alt="$t('history.list.2021.may.goal')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.dec.goal2')" tag="p" />
              <html-view :value="$t('history.list.2023.dec.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2023-11" class="animation up">{{ $t('history.month.nov') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.nov.goal1')" tag="p" />
              <html-view :value="$t('history.list.2023.nov.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.nov.goal2')" tag="p" />
              <html-view :value="$t('history.list.2023.nov.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202311@x3.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202311@x3.jpg 3x">
                <img src="~@/static/image/history/pc/202311.jpg" :alt="$t('history.list.2021.may.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2023-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.oct.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.oct.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2023-09" class="animation up">{{ $t('history.month.sep') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.sep.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.sep.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202309@x3.png 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202309@x3.png 3x">
                <img src="~@/static/image/history/pc/202309.png" :alt="$t('history.list.2021.may.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2023-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.aug.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.aug.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202308@x3.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202308@x3.jpg 3x">
                <img src="~@/static/image/history/pc/202308.jpg" :alt="$t('history.list.2021.may.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2023-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.jun.goal1')" tag="p" />
              <html-view :value="$t('history.list.2023.jun.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.jun.goal2')" tag="p" />
              <html-view :value="$t('history.list.2023.jun.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2023-05" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.may.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.may.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-right image-m-right animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202305@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202305@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202305.jpg" :alt="$t('history.list.2021.may.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2023-04" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.apr.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.apr.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2023-02" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2023.feb.goal')" tag="p" />
              <html-view :value="$t('history.list.2023.feb.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202302@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202302@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202302.jpg" :alt="$t('history.list.2023.feb.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2022" class="year article-anchor">
        <div class="year-head">
          <time>2022</time>
          <html-view :value="$t('history.list.2022.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2022-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.dec.goal1')" tag="p" />
              <html-view :value="$t('history.list.2022.dec.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.dec.goal2')" tag="p" />
              <html-view :value="$t('history.list.2022.dec.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2022-11" class="animation up">{{ $t('history.month.nov') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.nov.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.nov.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2022-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.oct.goal1')" tag="p" />
              <html-view :value="$t('history.list.2022.oct.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.oct.goal2')" tag="p" />
              <html-view :value="$t('history.list.2022.oct.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-default image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202210@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202210@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202210.jpg" :alt="$t('history.list.2022.oct.goal2')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2022-09" class="animation up">{{ $t('history.month.sep') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.sep.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.sep.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202209@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202209@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202209.jpg" :alt="$t('history.list.2022.sep.goal2')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2022-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.aug.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.aug.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202208@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202208@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202208.jpg" :alt="$t('history.list.2022.aug.goal2')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2022-07" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.jul.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.jul.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2022-04" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.apr.goal1')" tag="p" />
              <html-view :value="$t('history.list.2022.apr.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202204@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202204@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202204.jpg" :alt="$t('history.list.2022.apr.goal')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.apr.goal2')" tag="p" />
              <html-view :value="$t('history.list.2022.apr.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2022-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2021-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2022.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2022.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2021" class="year article-anchor">
        <div class="year-head">
          <time>2021</time>
          <html-view :value="$t('history.list.2021.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2021-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2021.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-center animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202112@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202112@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202112.jpg" :alt="$t('history.list.2021.jun.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2021-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.oct.goal')" tag="p" />
              <html-view :value="$t('history.list.2021.oct.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2021-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.jun.goal')" tag="p" />
              <html-view :value="$t('history.list.2021.jun.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-default image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202106@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202106@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202106.jpg" :alt="$t('history.list.2021.jun.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2021-04" class="animation up">{{ $t('history.month.apr') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.apr.goal')" tag="p" />
            </div>
          </div>
          <div class="month month-202103">
            <time datetime="2021-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.mar.goal')" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-right animation up">
              <!--              <picture>-->
              <!--                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202103@3x.jpg 3x">-->
              <!--                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202103@3x.jpg 3x">-->
              <!--                <img src="~@/static/image/history/pc/202103.jpg" :alt="$t('history.list.2021.mar.goal')">-->
              <!--              </picture>-->
              <video
                muted
                loop
                autoplay
                playsinline
                poster="~@/static/image/history/pc/202103.jpg"
              >
                <source src="~@/static/video/company_history_shoplive.mp4" type="video/mp4">
                Sorry, your browser doesn't support embedded videos.
              </video>
            </div>
          </div>
          <div class="month">
            <time datetime="2021-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2021.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2021.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2020" class="year article-anchor">
        <div class="year-head">
          <time>2020</time>
          <html-view :value="$t('history.list.2020.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month month-202010">
            <time datetime="2020-10" class=" animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.oct.goal1')" tag="p" />
              <html-view :value="$t('history.list.2020.oct.goalDetail1')" class="month-goal-desc animation up" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202010@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202010@3x.jpg 3x">
                <img src="~@/static/image/history/pc/202010.jpg" :alt="$t('history.list.2020.oct.goal1')">
              </picture>
            </div>
            <div class="month-202010-2">
              <div class="month-goal month-goal-2 animation up">
                <html-view :value="$t('history.list.2020.oct.goal2')" tag="p" />
                <html-view :value="$t('history.list.2020.oct.goalDetail2')" class="month-goal-desc" tag="p" />
              </div>
              <div class="month-image month-image-2 image-pc-outer image-m-outer animation up">
                <picture>
                  <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/202010_2@3x.jpg 3x">
                  <source media="(max-width: 750px)" srcset="~@/static/image/history/m/202010_2@3x.jpg 3x">
                  <img src="~@/static/image/history/pc/202010_2.jpg" :alt="$t('history.list.2020.oct.goal2')">
                </picture>
              </div>
            </div>
          </div>
          <div class="month">
            <time datetime="2020-09" class="animation up">{{ $t('history.month.sep') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.sep.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2020-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.aug.goal')" tag="p" />
              <html-view :value="$t('history.list.2020.aug.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2020-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.mar.goal1')" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.mar.goal2')" tag="p" />
              <html-view :value="$t('history.list.2020.mar.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2020-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2020.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2020.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2019" class="year article-anchor">
        <div class="year-head">
          <time>2019</time>
          <html-view :value="$t('history.list.2019.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2019-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2019.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2019-11" class="animation up">{{ $t('history.month.nov') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.nov.goal')" tag="p" />
              <html-view :value="$t('history.list.2019.nov.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201911@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201911@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201911.jpg" :alt="$t('history.list.2019.nov.goal')">
              </picture>
            </div>
          </div>
          <div class="month month-201908">
            <div class="month-image image-pc-right image-m-right animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201908@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201908@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201908.jpg" :alt="$t('history.list.2019.aug.goal')">
              </picture>
            </div>
            <time datetime="2019-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.aug.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2019-7" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.jul.goal')" tag="p" />
              <html-view :value="$t('history.list.2019.jul.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2019-5" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.may.goal')" tag="p" />
              <html-view :value="$t('history.list.2019.may.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2019-2" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2019.feb.goal')" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2018" class="year article-anchor">
        <div class="year-head">
          <time>2018</time>
          <html-view :value="$t('history.list.2018.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2018-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.dec.goal1')" tag="p" />
              <html-view :value="$t('history.list.2018.dec.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201812@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201812@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201812.jpg" :alt="$t('history.list.2018.dec.goal')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.dec.goal2')" tag="p" />
              <html-view :value="$t('history.list.2018.dec.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2018-07" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.jul.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2018-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.jun.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2018-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.mar.goal1')" tag="p" />
              <html-view :value="$t('history.list.2018.mar.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201803@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201803@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201803.jpg" :alt="$t('history.list.2018.mar.goal1')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2018.mar.goal2')" tag="p" />
              <html-view :value="$t('history.list.2018.mar.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201803_2.gif">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201803_2.gif">
                <img src="~@/static/image/history/pc/201803_2.gif" :alt="$t('history.list.2018.mar.goal2')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2017" class="year article-anchor">
        <div class="year-head">
          <time>2017</time>
          <html-view :value="$t('history.list.2017.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2017-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2017.oct.goal')" tag="p" />
              <html-view :value="$t('history.list.2017.oct.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2017-07" class="animation up">{{ $t('history.month.jul') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2017.jul.goal')" tag="p" />
              <html-view :value="$t('history.list.2017.jul.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201707@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201707@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201707.jpg" :alt="$t('history.list.2017.jul.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2017-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2017.jun.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2017-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2017.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2017.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month month-201702">
            <time datetime="2017-02" class="animation up">{{ $t('history.month.feb') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2017.feb.goal')" tag="p" />
              <html-view :value="$t('history.list.2017.feb.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <div class="poster">
                <a
                  :href="require('@/static/download/poster_RGB.jpeg')"
                  @click.prevent="isDialog = true"
                >
                  <img src="~@/static/image/history/pc/201702.jpg" :alt="$t('history.list.2017.feb.goal')">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2016" class="year article-anchor">
        <div class="year-head">
          <time>2016</time>
          <html-view :value="$t('history.list.2016.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2016-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2016.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2016.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2016-08" class="animation up">{{ $t('history.month.aug') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2016.aug.goal')" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2016-05" class="animation up">{{ $t('history.month.may') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2016.may.goal')" tag="p" />
              <html-view :value="$t('history.list.2016.may.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-right-outer image-m-right animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201605@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201605@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201605.jpg" :alt="$t('history.list.2016.may.goal')">
              </picture>
            </div>
          </div>
          <div class="month month-201601">
            <div class="month-image image-pc-default image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201601@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201601@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201601.jpg" :alt="$t('history.list.2016.jan.goal')">
              </picture>
            </div>
            <time datetime="2016-01" class="animation up">{{ $t('history.month.jan') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2016.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2016.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2015" class="year article-anchor">
        <div class="year-head">
          <time>2015</time>
          <html-view :value="$t('history.list.2015.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2015-12" class="animation up">
              {{ $t('history.month.dec') }}
            </time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.jan.goal')" tag="p" />
              <html-view :value="$t('history.list.2015.jan.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-right animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201501@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201501@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201501.jpg" :alt="$t('history.list.2015.jan.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2015-10" class="animation up">{{ $t('history.month.oct') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.oct.goal')" tag="p" />
              <html-view :value="$t('history.list.2015.oct.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.oct.goal2')" tag="p" />
              <html-view :value="$t('history.list.2015.oct.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-inner image-m-inner animation up">
              <img src="~@/static/image/history/pc/201510.jpg" :alt="$t('history.list.2015.oct.goal')">
            </div>
          </div>
          <div class="month">
            <time datetime="2015-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.jun.goal1')" tag="p" />
              <html-view :value="$t('history.list.2015.jun.goalDetail1')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201506@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201506@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201506.jpg" :alt="$t('history.list.2015.jun.goal')">
              </picture>
            </div>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.jun.goal2')" tag="p" />
              <html-view :value="$t('history.list.2015.jun.goalDetail2')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-center animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201506_2@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201506_2@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201506_2.jpg" :alt="$t('history.list.2015.jun.goal')">
              </picture>
            </div>
          </div>
          <div class="month">
            <time datetime="2015-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2015.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2015.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
        </div>
      </div>

      <div id="history-2014" class="year article-anchor">
        <div class="year-head">
          <time>2014</time>
          <html-view :value="$t('history.list.2014.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2014-12" class="animation up">
              {{ $t('history.month.dec') }}
            </time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2014.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2014.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
          </div>
          <div class="month">
            <time datetime="2014-12" class="animation up">
              {{ $t('history.month.mar') }}
            </time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2014.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2014.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-full image-m-default animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201403@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201403@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201403.jpg" :alt="$t('history.list.2014.mar.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2013" class="year article-anchor">
        <div class="year-head">
          <time>2013</time>
          <html-view :value="$t('history.list.2013.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2013-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2013.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2013.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-right animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201303@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201303@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201303.jpg" :alt="$t('history.list.2013.mar.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2012" class="year article-anchor">
        <div class="year-head">
          <time>2012</time>
          <html-view :value="$t('history.list.2012.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2012-11" class="animation up">{{ $t('history.month.nov') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2012.nov.goal')" tag="p" />
              <html-view :value="$t('history.list.2012.nov.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-center animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201211@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201211@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201211.jpg" :alt="$t('history.list.2012.mar.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2011" class="year article-anchor">
        <div class="year-head">
          <time>2011</time>
          <html-view :value="$t('history.list.2011.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month">
            <time datetime="2011-03" class="animation up">{{ $t('history.month.mar') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2011.mar.goal')" tag="p" />
              <html-view :value="$t('history.list.2011.mar.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-outer image-m-outer animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201103@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/m/201103@3x.jpg 3x">
                <img src="~@/static/image/history/pc/201103.jpg" :alt="$t('history.list.2011.mar.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div id="history-2010" class="year article-anchor">
        <div class="year-head">
          <time>2010</time>
          <html-view :value="$t('history.list.2010.summary')" tag="p" class="year-head-summary" />
        </div>
        <div class="month-list">
          <div class="month month-201012">
            <time datetime="2010-12" class="animation up">{{ $t('history.month.dec') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2010.dec.goal')" tag="p" />
              <html-view :value="$t('history.list.2010.dec.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-center animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201012@3x.jpg">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/pc/201012.jpg">
                <img src="~@/static/image/service/pc/one.jpg" :alt="$t('history.list.2010.dec.goal')">
              </picture>
            </div>
          </div>
          <div class="month month-201006">
            <time datetime="2010-06" class="animation up">{{ $t('history.month.jun') }}</time>
            <div class="month-goal animation up">
              <html-view :value="$t('history.list.2010.jun.goal')" tag="p" />
              <html-view :value="$t('history.list.2010.jun.goalDetail')" class="month-goal-desc" tag="p" />
            </div>
            <div class="month-image image-pc-center image-m-center animation up">
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/history/pc/201006@3x.jpg">
                <source media="(max-width: 750px)" srcset="~@/static/image/history/pc/201006.jpg">
                <img src="~@/static/image/history/pc/201006.jpg" :alt="$t('history.list.2010.dec.goal')">
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="dialog"
      :class="{
        active: isDialog
      }"
    >
      <div class="dialog-dim" />
      <div class="dialog-wrap">
        <div class="dialog-head">
          <button type="button" class="btn-close" @click="isDialog = !isDialog">
            <icon-close />
          </button>
        </div>
        <div class="dialog-body">
          <img src="~@/static/image/history/pc/201702.jpg" :alt="$t('history.list.2017.feb.goal')">
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import animation from '@/mixins/animation'
import gtag from '@/mixins/gtag'
import { saveAs } from 'file-saver'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    // iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    iconClose: () => import('@/static/svg/close.svg'),
  },
  mixins: [
    animation,
    gtag
  ],
  data () {
    return {
      historySelectedText: null,
      historySelectedYear: this.$t('all'),
      isBetterShow: false,
      isDialog: false,
      activeMenu: this.$route.name.toString()
    }
  },
  computed: {
    nextYear () {
      // return Number(this.$moment().format('YYYY')) + 1
      // 히스토리중 마지막년도를 찾아 반영
      const year = Object.keys(this.$t('history')).filter(item => {
        return !isNaN(Number(item))
      })

      return Number(year[year.length - 1]) + 1
    },
    currentYear () {
      return Number(this.$moment().format('YYYY'))
    },
    navHistory () {
      return this.chunkArray(Object.keys(this.$t('history.list')), 5).map(item => {
        return {
          anchor: `history-${item[item.length - 1]}`,
          title: item.length > 1 ? `${item[0]} ~ ${item[item.length - 1]}` : item[0]
        }
      })
    }
  },
  watch: {
    '$route.params.locale' () {
      this.historySelectedYear = this.$t('all')
      this.historySelectedText = null
    }
  },
  mounted () {
    if (this.$route.params.child === 'history' && this.$route.hash) {
      this.onSelectHistory(this.$route.hash.replace('#history-', ''))
    }
    this.$emit('loaded:component')

    this.initGtag({
      element: this.$el,
      isView: true,
      ga: {
        name: '회사소개_히스토리',
        category: '회사소개_히스토리',
        label: '회사소개_히스토리',
        page: '회사소개'
      }
    })
  },
  methods: {
    reverseObject (object) {
      return Object.entries(object)
          .sort(([keyA], [keyB]) => Number(keyB) - Number(keyA))
    },
    chunkArray (array, chunkSize) {
      const result = []

      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize))
      }

      return result.reverse()
    },
    onBetterToggle () {
      this.isBetterShow = !this.isBetterShow

      const docEvents = (e) => {
        if (!e.target.closest('.link-select')) {
          this.isBetterShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    },
    onSelectHistory (year, text) {
      this.isBetterShow = false

      if (!year) {
        this.$router.replace({
          hash: ''
        }).catch(e => {
        })
      }

      this.historySelectedYear = year
      this.historySelectedText = text
    },
    isHistory (year) {
      return this.historySelectedYear === this.$t('all') ? true : this.historySelectedYear === year
    },
    fileDownload (e) {
      const target = e.currentTarget

      fetch(target.href)
          .then(response => response.blob())
          .then(blob => {
            saveAs(blob, target.getAttribute('download'))

            this.downloading = false
          })
          .catch(e => console.error(e))
    }
  }
}
</script>
